import React from "react";
import { LoadingSpinner } from "../Loading";

// Primary Button - Main actions (compact blue button)
export const PrimaryButton = ({
  children,
  onClick,
  disabled = false,
  loading = false,
  className = "",
  type = "button",
  loadingText,
  icon: Icon,
  ...props
}) => {
  // Filter out props that shouldn't go to the DOM
  const { loadingText: _, icon: __, ...buttonProps } = props;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`
        bg-brand-gold text-brand-charcoal px-3 py-2 max-lg:min-h-11 text-sm font-display font-bold tracking-wide
        rounded-lg
        hover:bg-brand-gold/90
        focus:outline-none focus:ring-2 focus:ring-brand-gold
        transition-colors duration-200
        inline-flex items-center justify-center space-x-2
        disabled:opacity-50 disabled:cursor-not-allowed
        ${className}
      `}
      {...buttonProps}
    >
      {loading && <LoadingSpinner size="sm" />}
      {Icon && <Icon className="w-4 h-4" />}
      {children}
    </button>
  );
};

export default PrimaryButton;
